import React from "react"
import { useTranslation } from "react-i18next"

import { hasPermissions } from "apps/auth/auth"
import BookingFareList from "apps/fares/BookingFare/BookingFareList"
import Button from "components/Button/Button"
import Icon from "components/Icon/Icon"
import { actionsColumn } from "components/Table"
import Tooltip from "components/Tooltip/Tooltip"
import { reverse } from "utils/urls"

export default function TourOperatorBookingFareList(props) {
  const { t } = useTranslation()

  return (
    <BookingFareList
      tableConfig={{
        endpoint: "/fares/tour-operator-fares",
        title: t("Tour Operator Booking Fares"),
        tableName: "tour-operator-booking-fare-table-config",
        buttons: (
          <>
            {hasPermissions(["add_fares_touroperatorbookingfare"]) && (
              <Button icon="plus" to={reverse("tourOperatorBookingFareCreate")}>
                {t("Add Fare")}
              </Button>
            )}
          </>
        ),
      }}
      actionsColumn={actionsColumn(obj => (
        <>
          <Tooltip title={t("Fare History")}>
            <Icon.Link
              name="history"
              color="gray"
              to={reverse("history", {
                id: obj.id,
                model: encodeURIComponent("fares/tour-operator-fares"),
              })}
            />
          </Tooltip>
          <Tooltip title={t("Edit Fare")}>
            <Icon.Link
              name="edit"
              linkClassName="ml-3"
              to={reverse("tourOperatorBookingFareUpdate", { id: obj.id })}
            />
          </Tooltip>
          <Tooltip title={t("Delete Fare")}>
            <Icon.Link
              name="remove"
              color="danger"
              linkClassName="ml-3"
              to={reverse("tourOperatorBookingFareDelete", { id: obj.id })}
            />
          </Tooltip>
        </>
      ))}
    />
  )
}
